import React from 'react';
import { Link } from 'react-router-dom';

export default function CGU() {
  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white relative">
      {/* Background Effects */}
      <div className="fixed inset-0 green-gradient opacity-50"></div>
      <div className="fixed top-20 left-1/4 w-[500px] h-[500px] bg-[#00FF9D]/5 rounded-full blur-[100px]"></div>
      <div className="fixed bottom-20 right-1/4 w-[500px] h-[500px] bg-[#00FF9D]/5 rounded-full blur-[100px]"></div>

      {/* Content */}
      <div className="relative z-10 max-w-[1400px] mx-auto px-4 py-12">
        <Link to="/" className="inline-flex items-center gap-2 text-[#00FF9D] hover:text-[#00FF9D]/80 mb-8">
          <span>← Retour</span>
        </Link>
        
        <h1 className="text-4xl font-bold mb-8 mono text-center">CONDITIONS GÉNÉRALES D'UTILISATION DE L'EXTENSION TARSS</h1>
        
        <div className="prose prose-invert max-w-none">
          <section className="mb-12">
            <h2 className="text-2xl font-bold mb-4 text-[#00FF9D]">PRÉSENTATION DE L'EXTENSION</h2>
            <p className="text-gray-400">
              Tarss est une extension de navigateur Chrome développée par Kepler And Co., permettant aux utilisateurs 
              de capturer et d'agréger des opportunités professionnelles et des profils publiés publiquement sur LinkedIn.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-bold mb-4 text-[#00FF9D]">ACCEPTATION DES CONDITIONS</h2>
            <p className="text-gray-400">
              En installant l'extension Tarss, vous acceptez expressément les présentes conditions générales d'utilisation. 
              Si vous n'acceptez pas ces conditions, vous ne devez pas utiliser l'extension.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-bold mb-4 text-[#00FF9D]">FONCTIONNALITÉS DE L'EXTENSION</h2>
            
            <h3 className="text-xl font-bold mb-3 text-white">3.1. Collecte de données</h3>
            <ul className="list-disc pl-6 text-gray-400 mb-6">
              <li>L'extension collecte uniquement les données publiques présentes dans votre feed LinkedIn</li>
              <li>Les données collectées concernent les offres de missions et les profils professionnels</li>
              <li>Seules les informations publiquement accessibles sont collectées</li>
            </ul>

            <h3 className="text-xl font-bold mb-3 text-white">3.2. Partage des données</h3>
            <ul className="list-disc pl-6 text-gray-400">
              <li>Les données collectées sont partagées au sein de la communauté Tarss</li>
              <li>Les utilisateurs ont accès aux opportunités collectées par l'ensemble de la communauté</li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-bold mb-4 text-[#00FF9D]">ENGAGEMENT DES UTILISATEURS</h2>
            <p className="text-gray-400 mb-4">L'utilisateur s'engage à :</p>
            <ul className="list-disc pl-6 text-gray-400">
              <li>Ne pas utiliser l'extension à des fins malveillantes</li>
              <li>Ne pas tenter d'extraire des données privées</li>
              <li>Ne pas revendre ou commercialiser les données collectées</li>
              <li>Respecter les conditions d'utilisation de LinkedIn</li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-bold mb-4 text-[#00FF9D]">PROTECTION DES DONNÉES PERSONNELLES</h2>
            
            <h3 className="text-xl font-bold mb-3 text-white">5.1. Données collectées</h3>
            <ul className="list-disc pl-6 text-gray-400 mb-6">
              <li>Informations de profil LinkedIn publiques</li>
              <li>Offres de missions publiées publiquement</li>
              <li>Données de navigation liées à l'utilisation de l'extension</li>
            </ul>

            <h3 className="text-xl font-bold mb-3 text-white">5.2. Utilisation des données</h3>
            <ul className="list-disc pl-6 text-gray-400 mb-6">
              <li>Amélioration des fonctionnalités de l'extension</li>
              <li>Mise en relation entre offres et candidats</li>
              <li>Analyses statistiques anonymisées</li>
            </ul>

            <h3 className="text-xl font-bold mb-3 text-white">5.3. Conservation des données</h3>
            <ul className="list-disc pl-6 text-gray-400">
              <li>Les données sont conservées pendant la durée d'utilisation de l'extension</li>
              <li>Les utilisateurs peuvent demander la suppression de leurs données</li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-bold mb-4 text-[#00FF9D]">LIMITATIONS DE RESPONSABILITÉ</h2>
            <h3 className="text-xl font-bold mb-3 text-white">6.1. Kepler And Co. ne peut être tenue responsable :</h3>
            <ul className="list-disc pl-6 text-gray-400">
              <li>Des contenus publiés sur LinkedIn</li>
              <li>De l'exactitude des informations collectées</li>
              <li>Des modifications apportées à l'API LinkedIn</li>
              <li>Des interruptions de service</li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-bold mb-4 text-[#00FF9D]">PROPRIÉTÉ INTELLECTUELLE</h2>
            <ul className="list-disc pl-6 text-gray-400">
              <li>L'extension Tarss et tous ses composants sont la propriété exclusive de Kepler And Co.</li>
              <li>L'utilisation de l'extension ne confère aucun droit de propriété à l'utilisateur</li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-bold mb-4 text-[#00FF9D]">MODIFICATIONS DES CGU</h2>
            <p className="text-gray-400">
              Kepler And Co. se réserve le droit de modifier les présentes CGU à tout moment. Les utilisateurs 
              seront informés des modifications substantielles.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-bold mb-4 text-[#00FF9D]">RÉSILIATION</h2>
            
            <h3 className="text-xl font-bold mb-3 text-white">9.1. Par l'utilisateur</h3>
            <ul className="list-disc pl-6 text-gray-400 mb-6">
              <li>L'utilisateur peut cesser d'utiliser l'extension à tout moment</li>
              <li>La désinstallation entraîne la suppression des données collectées</li>
            </ul>

            <h3 className="text-xl font-bold mb-3 text-white">9.2. Par Kepler And Co.</h3>
            <ul className="list-disc pl-6 text-gray-400">
              <li>En cas de non-respect des présentes CGU</li>
              <li>En cas d'utilisation frauduleuse de l'extension</li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-bold mb-4 text-[#00FF9D]">LOI APPLICABLE ET JURIDICTION</h2>
            <p className="text-gray-400">
              Les présentes CGU sont soumises au droit français. Tout litige relatif à leur interprétation 
              ou leur exécution relève des tribunaux français.
            </p>
          </section>

          <div className="text-gray-400 text-sm mt-16">
            <p>Date de dernière mise à jour : 30/01/2025</p>
          </div>
        </div>
      </div>
    </div>
  );
} 